import { useError } from "../../context/ErrorProvider";
import { CircleAlert, X } from "lucide-react";

const ErrorModal = () => {
  const { error, clearError } = useError();

  if (!error) return null;

  return (
    <div
      onClick={clearError}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md rounded-xl bg-white px-6 py-5 shadow-2xl"
      >
        {/* Close Button */}
        <button
          onClick={clearError}
          className="absolute right-3 top-3 rounded-full bg-red-500 p-1 hover:bg-red-600 transition"
        >
          <X size={16} color="white" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-2">
          <CircleAlert size={18} className="text-red-500" />
          <h2 className="text-lg font-semibold text-red-600">Error</h2>
        </div>

        {/* Message */}
        <p className="mt-3 text-sm text-gray-700">{error}</p>
      </div>
    </div>
  );
};

export default ErrorModal;
